export default {
  currentTicketItem: state => state.current
}
